export const blockIconsNotificationDoDisturbOn = (
	<span className='material-symbols-outlined'>do_disturb_on</span>
);
